export const SHARE_BUTTON_NAMES = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    LINKEDIN: 'linkedin',
};
export const DOWNLOAD_TICKETS_BUTTON_NAMES = {
    PDF: 'download_pdf',
    APPLE_WALLET: 'add_to_apple_wallet',
};
export const BI_ORIGINS = {
    MEMBERS_AREA: 'members area',
    WIDGET: 'widget',
    EVENT_DETAILS: 'event details',
    THANK_YOU_PAGE: 'thank you page',
    MAP: 'map',
    SEATINGS_MODAL_TICKET_LIST: 'ticket_list',
    SEATINGS_MODAL_BASKET: 'basket',
};
export const BI_ENDPOINTS = {
    EVENTS_UOU: 'events-uou',
    EVENTS_USERS: 'events-users',
};
export const MODAL_BUTTONS = {
    CONTINUE: 'continue',
    CANCEL: 'cancel',
    X: 'x',
    SAVE_LEAVE: 'save_leave',
    DISCONNECT: 'disconnect',
    TURN_OFF: 'turn_off',
    SHOW_PRICES: 'show_prices',
    HIDE_PRICES: 'hide_prices',
    ZOOM_IN: 'zoom_in',
    ZOOM_OUT: 'zoom_out',
};
export const CUSTOM_DATES_BANNER_NAMES = {
    TICKETS: 'tickets',
    REGISTRATION_SETTINGS: 'registration_settings',
    PAST_EVENT: 'past_event',
};
export const WARNING_BANNER_NAMES = {
    NO_TICKETS: 'no_tickets',
    TICKET_MAPPING: 'ticket_mapping',
};
//# sourceMappingURL=bi.js.map